import React from 'react';

import moment from 'moment';
import {
  Table,
  Tooltip,
  Select,
  Button,
  InputNumber,
  DatePicker,
} from 'antd/lib';
import * as Icons from '@ant-design/icons';
import { Form } from '@ant-design/compatible';

import Loading from '../../common/Loading';
import _ from 'lodash';

import { graphql, compose } from 'react-apollo';

import getTipoSellos from '../../../graphql/querys/ventas/getTipoSellos.graphql';
import getOrganismos from '../../../graphql/querys/organismos/getOrganismos.graphql';
import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';

// import SelectorModelo from './SelectorModelo'
const FormItem = Form.Item;
const Option = Select.Option;

@compose(
  graphql(getUsuario),
  graphql(getOrganismos, { name: 'organismos' }),
  graphql(getTipoSellos, { name: 'tipoSellos' })
)
class FormCrearPedido extends React.Component {
  constructor(props) {
    super(props);

    // let listaTiposSellos = this.props.data.getTiposSellos;
    this.state = {
      confirmDirty: false,
      autoCompleteResult: [],
      listaTiposSellos: this.props.tipoSellos.getTiposSellos
        ? this.props.tipoSellos.getTiposSellos
        : [],
      itemsVenta: [],
      itemTipoSeleccionado: '',
      cantTipoSeleccionada: '',
    };

    this.agregarItemVenta = this.agregarItemVenta.bind(this);
    this.devolverNombre = this.devolverNombre.bind(this);
    this.eliminarItem = this.eliminarItem.bind(this);
    this.calcularMontoTotal = this.calcularMontoTotal.bind(this);
  }

  cambiarOrganismo = idOrganismo => {
    this.setState({
      ...this.state,
      idOrganismo: idOrganismo,
      nombreOrganismo: this.obtenerNombreOrganismo(idOrganismo),
    });
  };

  obtenerNombreOrganismo = idOrganismo => {
    let nombre = '';
    let organismo = _.find(this.props.organismos.getOrganismos, {
      _id: idOrganismo,
    });
    organismo
      ? (nombre = organismo.nombre)
      : (nombre = this.props.usuario.getUsuario.organismo.nombre);
    return nombre;
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    // console.log("Voy a recibir nuevas props", nextProps);
    if (
      !this.props.tipoSellos.getTiposSellos &&
      nextProps.tipoSellos.getTiposSellos
    ) {
      this.setState(
        {
          ...this.state,
          listaTiposSellos: nextProps.tipoSellos.getTiposSellos,
        },
        function() {
          // console.log("Datos actualizados!")
        }
      );
    }
  }

  calcularMontoTotal() {
    // console.log("Entre a calcular el monto final");
    let montoFinal = 0;

    let yo = this;
    // console.log("El estado actual es de.....");
    // console.log(this.state);
    _.each(this.state.itemsVenta, function(item) {
      // console.log("entre a calcular con monto con...", item);
      var tipoSelloItem = _.find(yo.state.listaTiposSellos, function(
        tipoSello
      ) {
        // console.log("entre a buscar con....", tipoSello);
        return item.idTipo_Sello === tipoSello._id;
      });

      if (tipoSelloItem) {
        montoFinal = montoFinal + tipoSelloItem.valor * item.cantidad;
      }
    });

    // console.log("el monto final es...: ", montoFinal);
    return montoFinal;
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        // console.log("Received values of form: ", values);
        values.importe = this.calcularMontoTotal();
        values.detalle = this.state.itemsVenta;
        this.props.onSubmit(values);
      }
    });
  };

  handleConfirmBlur = e => {
    const value = e.target.value;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };

  checkConfirm = (rule, value, callback) => {
    const form = this.props.form;
    if (value && this.state.confirmDirty) {
      form.validateFields(['confirm'], { force: true });
    }
    callback();
  };

  handleChange = valor => {
    // console.log('HANDLE: ', valor);
    this.setState({
      ...this.state,
      itemTipoSeleccionado: valor,
      cantTipoSeleccionada: 500,
    });
  };

  cambioNumero = valor => {
    this.setState({
      ...this.state,
      cantTipoSeleccionada: valor,
    });
  };

  agregarItemVenta() {
    let nuevoItemsVenta = this.state.itemsVenta;
    let nuevoDetalle = {
      idTipo_Sello: this.state.itemTipoSeleccionado,
      cantidad: this.state.cantTipoSeleccionada,
      numeracionInicial: this.state.numeracionInicial,
      numeracionFinal: this.state.numeracionFinal,
    };
    nuevoItemsVenta.push(nuevoDetalle);

    //YA NO AGRUPAMOS MAS, POR EL TEMA DE LA NUMERACION DE LOS SELLOS

    var output = _(nuevoItemsVenta)
      .groupBy('idTipo_Sello')
      .map((objs, key) => ({
        idTipo_Sello: key,
        cantidad: _.sumBy(objs, 'cantidad'),
      }))
      .value();

    this.setState({
      ...this.state,
      itemsVenta: output,
      itemTipoSeleccionado: '',
      cantTipoSeleccionada: '',
    });
  }

  eliminarItem(idTipo_Sello) {
    let nuevoItemsVenta = this.state.itemsVenta;

    // console.log("ELiminar");
    // console.log(idTipo_Sello);
    // console.log(numInicial);
    // console.log(numFinal);
    // console.log(nuevoItemsVenta);

    _.remove(nuevoItemsVenta, {
      idTipo_Sello: idTipo_Sello,
    });

    this.setState({
      ...this.state,
      itemsVenta: nuevoItemsVenta,
    });
  }

  crearOpciones(tipoSello) {
    return (
      <Option key={tipoSello._id} value={tipoSello._id}>
        {tipoSello.nombre}
      </Option>
    );
  }

  crearOpcionesOrganismos = organismo => {
    return (
      <Option key={organismo._id} value={organismo._id}>
        {organismo.nombre}
      </Option>
    );
  };

  devolverNombre(idTipoSello) {
    // console.log("ENTRE CON: ", idTipoSello);
    // console.log(this.state.listaTiposSellos);
    let objeto = _.find(this.state.listaTiposSellos, { _id: idTipoSello });
    return objeto.nombre;
  }

  render() {
    // console.log("PROPS");
    // console.log(this.props);
    const { getFieldDecorator } = this.props.form;
    const { opcionRender } = this.props; //Esta variable sirve para saber si se debe renderizar como form o como input
    let opcionFormulario = opcionRender ? opcionRender : 1;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    let listaTiposSellos = this.props.tipoSellos.getTiposSellos;
    if (listaTiposSellos) {
      var opciones = _.map(listaTiposSellos, this.crearOpciones);
    } else {
      return <Loading />;
    }

    const listaOrganismos = this.props.organismos.getOrganismos;
    if (listaOrganismos) {
      var opcionesOrganismos = _.map(
        listaOrganismos,
        this.crearOpcionesOrganismos
      );
    }

    let usuario = this.props.data.getUsuario;

    let columnasTabla = [];
    if (this.state.itemsVenta) {
      let yo = this;
      _.forEach(this.state.itemsVenta, function(value) {
        // console.log(value);
        columnasTabla.push({
          key: Math.random() * (10000000 - 1) + 1,
          nombre: yo.devolverNombre(value.idTipo_Sello),
          cantidad: value.cantidad,
          idTipo_Sello: value.idTipo_Sello,
          numeracionInicial: value.numeracionInicial,
          numeracionFinal: value.numeracionFinal,
        });
      });
    }

    return (
      <div>
        <h1 className="tituloForm">Datos del Pedido</h1>

        {opcionFormulario == 0 && (
          <Form onSubmit={this.handleSubmit} className="formularios">
            <FormItem {...tailFormItemLayout}>
              <Button type="primary" htmlType="submit">
                Buscar
              </Button>
            </FormItem>
          </Form>
        )}

        {opcionFormulario == 1 && (
          <div>
            <FormItem
              {...formItemLayout}
              label={
                <span>
                  Fecha del pedido
                  <Tooltip title="Seleccione la fecha de que se efectuó el pedido">
                    <Icons.QuestionCircleOutlined />
                  </Tooltip>
                </span>
              }
            >
              {getFieldDecorator('fechaPedido', {
                initialValue: moment(),
                rules: [
                  {
                    type: 'object',
                    required: true,
                    message: 'Por favor, seleccione la fecha del pedido',
                  },
                ],
              })(
                <DatePicker
                  disabled={usuario.organismo._id != '00004'}
                  style={{ width: 380, marginRight: 20 }}
                  placeholder="Fecha del pedido"
                  format="DD/MM/YYYY"
                />
              )}
            </FormItem>

            <FormItem
              {...formItemLayout}
              label={
                <span>
                  Organismo receptor del pedido
                  <Tooltip title="Seleccione el organismo receptor">
                    <Icons.QuestionCircleOutlined />
                  </Tooltip>
                </span>
              }
            >
              {getFieldDecorator('idOrganismo', {
                initialValue: usuario.organismo._id,
                rules: [
                  {
                    required: true,
                    message: 'Por favor, ingrese el organismo!',
                  },
                ],
              })(
                <Select
                  showSearch
                  style={{ width: 380 }}
                  placeholder="Seleccione un organismo"
                  disabled={usuario.organismo._id != '00004'}
                  onSelect={valor => this.cambiarOrganismo(valor)}
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {opcionesOrganismos}
                </Select>
              )}
            </FormItem>

            <FormItem
              {...formItemLayout}
              label={
                <span>
                  Tipo Sello
                  <Tooltip title="Seleccione los sellos que fueron enviados">
                    <Icons.QuestionCircleOutlined />
                  </Tooltip>
                </span>
              }
            >
              <div>
                <Select
                  showSearch
                  style={{ width: 380, marginRight: 20 }}
                  /* eslint-disable-next-line react/no-string-refs */
                  ref="selectTipoSello"
                  placeholder="Seleccione un tipo de tasa"
                  optionFilterProp="children"
                  onChange={this.handleChange}
                  value={this.state.itemTipoSeleccionado}
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {opciones}
                </Select>
                Cantidad:
                <InputNumber
                  value={this.state.cantTipoSeleccionada}
                  onChange={this.cambioNumero}
                  /* eslint-disable-next-line react/no-string-refs */
                  ref="cantTipoSello"
                  style={{ marginLeft: 10, marginRight: 20 }}
                  min={50}
                  max={10000}
                  step={50}
                  defaultValue={500}
                />
                <Button
                  type="primary"
                  onClick={this.agregarItemVenta}
                  disabled={!this.state.itemTipoSeleccionado}
                >
                  Agregar
                </Button>
              </div>
            </FormItem>
          </div>
        )}

        {this.state.itemsVenta.length > 0 && (
          <h1 style={{ textAlign: 'center', marginLeft: 55 }}>
            {' '}
            Detalle del Pedido{' '}
          </h1>
        )}
        {this.state.itemsVenta.length > 0 && <hr />}
        {this.state.itemsVenta.length > 0 && (
          <Table
            style={{ maxWidth: 650, marginLeft: '20%' }}
            dataSource={columnasTabla}
            pagination={false}
            columns={[
              { title: 'Nombre', dataIndex: 'nombre', key: 'nombre' },
              { title: 'Cantidad', dataIndex: 'cantidad', key: 'cantidad' },
              {
                title: 'Acciones',
                key: 'acccion',
                render: record => (
                  <span>
                    <Button
                      type="danger"
                      onClick={() => this.eliminarItem(record.idTipo_Sello)}
                    >
                      Eliminar
                    </Button>
                  </span>
                ),
              },
            ]}
          />
        )}

        {this.state.itemsVenta.length > 0 && (
          <h3 style={{ textAlign: 'center' }}>
            Monto Total:{' '}
            {this.calcularMontoTotal().toLocaleString('es-AR', {
              style: 'currency',
              currency: 'ARS',
            })}
          </h3>
        )}

        {this.state.itemsVenta.length > 0 && (
          <Button
            type="primary"
            style={{ textAlign: 'center', marginLeft: '45%' }}
            onClick={this.handleSubmit}
          >
            Generar Pedido
          </Button>
        )}
      </div>
    );
  }
}

export default Form.create()(FormCrearPedido);
